import { ContentNode, Repository } from '../types/Explorer';
import {
  DOWNLOAD_FOLDER_URL,
  GET_CHILDREN_NODES_URL,
  REPOSITORY_URL
} from '../constants/ApiUri';

import { Http } from 'vrlcm-gui-utils';

export const getRepositories = async (): Promise<Repository[]> => {
  const response = await Http.get<Repository[]>(REPOSITORY_URL);
  return response.data;
};

export const getChildrenNodes = async (
  parentId: string
): Promise<ContentNode[]> => {
  const response = await Http.get<ContentNode[]>(
    GET_CHILDREN_NODES_URL(parentId)
  );
  return response.data;
};

export const downloadFolder = async (contentPath: string) => {
  const response = await Http.post(DOWNLOAD_FOLDER_URL, [contentPath]);
  return response.data;
};
